module.exports = __webpack_public_path__ + "static/media/nin_verification_hero2.b2e64c4e.png";